module.exports = __webpack_public_path__ + "public/img/j7ycntj.0599a7dd.png";